import { useParams, Link, Navigate } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { FACILITIES, CONTACT } from "@/data/site";

export default function FacilityDetail() {
  const { slug } = useParams();
  const facility = FACILITIES.find((f) => f.slug === slug);
  if (!facility) return <Navigate to="/facilities" replace />;

  return (
    <div data-testid={`facility-detail-page-${facility.slug}`}>
      <PageHero overline="Facilities" title={facility.name} subtitle={facility.short} image={facility.image} />
      <section className="py-24 md:py-32 max-w-5xl mx-auto px-6 md:px-12">
        <Link to="/facilities" className="inline-flex items-center gap-2 text-white/50 hover:text-[#d4af37] text-sm mb-12 transition-colors duration-300" data-testid="back-to-facilities-link">
          <ArrowLeft size={15} /> All Facilities
        </Link>
        <FadeUp>
          <p className="text-[#a3a3a3] leading-relaxed text-lg">{facility.description}</p>
          <h2 className="font-serif-display text-2xl md:text-3xl font-light text-white mt-14 mb-8">Highlights</h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {facility.highlights.map((h) => (
              <li key={h} className="flex items-center gap-3 text-sm text-white/70 border hairline p-4">
                <Check size={15} className="text-[#d4af37] shrink-0" /> {h}
              </li>
            ))}
          </ul>
          <div className="mt-14 flex flex-wrap gap-4">
            <Link to="/book" className="btn-gold px-8 py-4 text-[12px] tracking-[0.2em] uppercase font-semibold" data-testid="facility-book-btn">Book Your Stay</Link>
            <a href={`mailto:${CONTACT.emails.info}`} className="btn-outline-gold px-8 py-4 text-[12px] tracking-[0.2em] uppercase" data-testid="facility-enquire-btn">Enquire by Email</a>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
